// @ts-nocheck

import React from 'react';

import CommonForm from

'../../../components/hoc/common/handbook/CommonForm';

import Grid, { GridItem } from '../../../components/layout/Grid';
import { FormField } from '../../../components/Form';
import VehicleTaxRateSelect from '../../../components/selects/VehicleTaxRateSelect';
import VehicleTypeSelect from '../../../components/selects/VehicleTypeSelect';


export default (props) => {
  return (
    <CommonForm {...props}>
      {({ setFieldValue }) => {
        return (
          <>
            <Grid gutter="16px">
              <GridItem>
                <FormField
                  label="Наименование объекта налогообложения"
                  fast
                  required
                  name="vehicleTaxRateId">

                  {({ name, value }) =>
                  <VehicleTaxRateSelect
                    value={value}
                    onChange={(value) => setFieldValue(name, value)} />

                  }
                </FormField>
              </GridItem>
              <GridItem>
                <FormField label="Тип ТС" fast required name="vehicleType">
                  {({ name, value }) =>
                  <VehicleTypeSelect
                    resultAsObject
                    onChange={({ type }) => {
                      setFieldValue(name, type);
                    }}
                    value={value} />

                  }
                </FormField>
              </GridItem>
            </Grid>
          </>);

      }}
    </CommonForm>);

};
